/**
 * Boxes travel as page-normalised coordinates (0..1, origin top-left) so a region means
 * the same thing at every render resolution. This is the only place that turns them
 * into pixels.
 */
export interface BBoxNorm {
  x0: number;
  y0: number;
  x1: number;
  y1: number;
}

export interface PixelRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

const clamp01 = (v: number) => Math.min(1, Math.max(0, v));

export function bboxToCanvas(bbox: BBoxNorm, canvasWidth: number, canvasHeight: number): PixelRect {
  const left = clamp01(Math.min(bbox.x0, bbox.x1));
  const right = clamp01(Math.max(bbox.x0, bbox.x1));
  const top = clamp01(Math.min(bbox.y0, bbox.y1));
  const bottom = clamp01(Math.max(bbox.y0, bbox.y1));
  return {
    x: left * canvasWidth,
    y: top * canvasHeight,
    width: (right - left) * canvasWidth,
    height: (bottom - top) * canvasHeight,
  };
}
